import React from "react";
import { GiClothes, GiSewingMachine } from "react-icons/gi";
import { TbIroningSteam } from "react-icons/tb"; // use existing icon
import { BiSolidWasher } from "react-icons/bi";
import { MdDryCleaning } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { convertToMMDDYYYY, dateFormat } from "../../../utils/dateFormat";
import { useLocation, useNavigate } from "react-router-dom";
import { clearOrderDetails, removeCartItem } from "../../../Redux/Slices/customerSlice";
import { FaCircleCheck } from "react-icons/fa6";

const categories = {
  "Wash & Fold": BiSolidWasher,
  "Dry Cleaning": MdDryCleaning,
  Tailoring: GiSewingMachine,
  Ironing: TbIroningSteam,
};

const SummaryStepCard = ({ cart = {}, selectedPound, onRemoveItem }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const currentPath = location.pathname;
  const { selectedService, pickupDetails ,shopDetails ,cartItems ,orderFlow ,selectedShop} = useSelector(
    (state) => state.customer
  );
  const IconComponent = categories[selectedService] || GiClothes; // fallback

  const handleRemove = (item) => {
    dispatch(removeCartItem({name:item.name})); 
  };

  const pickupPage = "/pickup-details";
  const shopPage = "/review-place-order";
  const isShow = shopPage === location.pathname
  console.log(pickupDetails)
  return (
    <div className="w-full lgs:w-[320px] lg:w-[350px] xl:w-[400px] bg-white rounded-2xl shadow-[0_0_10px_rgba(0,0,0,0.06)]  self-start overflow-hidden">
      {/* Header */}
      <div className="flex items-center justify-center gap-3 py-[14px] bg-gradient-to-b from-[#00648A] to-[#3AB5F8] text-white rounded-t-2xl shadow-sm">
        <IconComponent className="text-xl" />
        <div>
          <div className="font-semibold text-xl">{selectedService}</div>
        </div>
      </div>

      <div className="h-[1px] bg-gray-200" />

      {/* Steps */}
      <div className="divide-y">

             {orderFlow ==='shop' && (
                <div className="p-4 flex gap-2 items-start hover:bg-gray-50 transition cursor-pointer">
            {selectedShop && Object.keys(selectedShop).length > 0  ? (
            <FaCircleCheck className="text-green-500 mt-1" />
          ) : (
            <span className="text-gray-400">○</span>
          )}
          <div className="flex-1">
            <div className="font-semibold">Select Shop</div>
            {selectedShop ? (
              <div className="text-sm text-gray-600">
                {selectedShop?.title}
              </div>
            ) : (
                <div className="text-xs text-gray-500 mt-2 italic">
              No pickup details available
            </div>
            )}
          
          </div>
        </div>
        )}
        {/* Address */}
        <div
          className={`p-4 flex gap-2 items-start transition `}
        >
          {pickupDetails?.address ? (
            <FaCircleCheck className="text-green-500 mt-1" />
          ) : (
            <span className="text-gray-400">○</span>
          )}
          <div>
            <div className="font-semibold">Address</div>
            {pickupDetails?.addressString ? (
              <div className="text-xs text-gray-600">
                {pickupDetails?.addressString}
              </div>
            ) : (
              <div className="text-xs text-gray-500 mt-2 italic">
                No address added yet
              </div>
            )}
          </div>
        </div>

        {/* Pickup time */}
        <div
          className={`p-4 flex gap-2 items-start transition `}
        >
          {pickupDetails?.pickupDate ? (
             <FaCircleCheck className="text-green-500 mt-1" />
          ) : (
            <span className="text-gray-400">○</span>
          )}
          {pickupDetails?.pickupDate ? (
            <div>
              <div className="font-semibold">Pickup Details</div>
              <div className="text-xs text-gray-600">
                {convertToMMDDYYYY(pickupDetails?.pickupDate)},{" "}
                {pickupDetails?.pickupTime}
              </div>
            </div>
          ) : (
            <div className="text-xs text-gray-500 mt-1 italic">
              No pickup details available
            </div>
          )}
        </div>

        {/* Delivery time */}
        <div
          className={`p-4 flex gap-2 items-start transition `}
          // className={`p-4 flex gap-2 items-start transition ${
          //   pickupDetails?.address && currentPath !== pickupPage
          //     ? "hover:bg-gray-50 cursor-pointer"
          //     : ""
          // }`}
          // onClick={() => {
          //   if (pickupDetails?.address && currentPath !== pickupPage)
          //     navigate(pickupPage);
          // }}
        >
          {pickupDetails?.deliveryDate ? (
             <FaCircleCheck className="text-green-500 mt-1" />
          ) : (
            <span className="text-gray-400">○</span>
          )}
          {pickupDetails?.deliveryDate ? (
            <div>
              <div className="font-semibold">Delivery Details</div>
              <div className="text-xs text-gray-600">
                {convertToMMDDYYYY(pickupDetails?.deliveryDate)},{" "}
                {pickupDetails?.deliveryTime}
              </div>
            </div>
          ) : (
            <div className="text-xs text-gray-500 mt-1 italic">
              No pickup details available
            </div>
          )}
        </div>

        {/* Selected services */}
        <div
          className={`p-4 flex gap-2 items-start transition`}
        >
          {cartItems.length > 0 ? (
             <FaCircleCheck className="text-green-500 mt-1" />
          ) : (
            <span className="text-gray-400">○</span>
          )}
          <div className="flex-1">
            <div className="font-semibold">Selected services</div>
            {cartItems?.length > 0 ? (
              <div className="mt-3 space-y-2">
                {cartItems?.map(
                  (item ,index) => (
                    <div
                      key={`${item.name}-${index}`}
                      className="relative flex flex-col bg-white rounded-lg px-3 py-2 shadow-[0_0_10px_rgba(0,0,0,0.09)] hover:shadow transition"
                    >
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <GiClothes className="text-[#3383B2] text-xl" />
                          <div className="flex flex-col text-xs">
                            <span className="font-medium text-gray-800">
                              {item?.name}
                              {selectedService !== "Wash & Fold" && 
                                <span>
                               {" "} - {" "}{item?.category || ""}
                              </span>
                            }
                            </span>
                            {selectedService === "Wash & Fold" ? (
                              <span className="text-[12px] text-[#666666]">
                               weight: {item?.weight || "No"} lbs
                              </span>
                            ) : (
                              <span className="text-[12px] text-[#666666]">
                                {/* {item?.category || ""} */}
                               count: {item?.weight}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="flex">
                            {!isShow && (
                                 <button
                                onClick={(e) => {
                                  handleRemove(item);
                                }}
                                className=" ml-2 px-2 py-1 text-[#CA3447] font-[500] bg-[#FFE4E7] text-xs rounded-full flex items-center justify-center"
                              >
                                ✕ Remove
                              </button>
                            )}
                        </div>
                      </div>

                      {selectedService === "Tailoring" &&
                        item?.tailoringType?.length > 0 && (
                          <div className="flex flex-wrap gap-1 mt-1">
                            {item?.tailoringType.map((type) => (
                              <span
                                key={type}
                                className="text-[10px] bg-blue-100 text-[#3383B2] font-[500] rounded-full px-2 py-0.5"
                              >
                                {type}
                              </span>
                            ))}
                          </div>
                        )}
                    </div>
                  )
                )}
              </div>
            ) : (
              <div className="text-xs text-gray-500 mt-2 italic">
                No items selected yet
              </div>
            )}
          </div>
        </div>

        {/* Shop selection */}
        {orderFlow ==='service' && (
                <div className="p-4 flex gap-2 items-start hover:bg-gray-50 transition cursor-pointer">
            {shopDetails && Object.keys(shopDetails).length > 0  ? (
            <FaCircleCheck className="text-green-500 mt-1" />
          ) : (
            <span className="text-gray-400">○</span>
          )}
          <div className="flex-1">
            <div className="font-semibold">Select Shop</div>
            {shopDetails ? (
              <div className="text-sm text-gray-600">
                {shopDetails?.title}
              </div>
            ) : (
                <div className="text-xs text-gray-500 mt-2 italic">
              No pickup details available
            </div>
            )}
          
          </div>
        </div>
        )}
  

        {/* Review */}
        <div className="p-4 flex gap-2 items-start hover:bg-gray-50 transition">
          <span className="text-gray-400">○</span>
          <div className="flex-1">
            <div className="font-semibold">Review and place order</div>
          </div>
        </div>
      </div>

      {/* Clear */}
      <div
        className="text-center text-sm text-[#3383B2] font-[500] cursor-pointer py-4 border-t hover:underline"
        onClick={() => {
          dispatch(clearOrderDetails());
          setTimeout(() => navigate("/customer-home"), 10);
        }}
      >
        Clear my order
      </div>
    </div>
  );
};

export default SummaryStepCard;
